"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldHelper = exports.TextFieldRoot = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var mixins_1 = require("../../mixins");
var tokens_1 = require("../../tokens");
var applyStatusColor = function (_a) {
    var status = _a.status;
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    ", ";\n"], ["\n    ",
        ";\n    ",
        ";\n"])), status === 'success' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n    "], ["\n        color: ", ";\n    "])), tokens_1.accent), status === 'error' && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: ", ";\n    "], ["\n        color: ", ";\n    "])), tokens_1.critical));
};
/**
 * ToDo: Переименовать в Field, т.к. данный функционал теперь используется и в Select.
 */
exports.TextFieldRoot = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n\n    display: block;\n    box-sizing: border-box;\n\n    ", ";\n    ", ";\n"], ["\n    ", ";\n\n    display: block;\n    box-sizing: border-box;\n\n    ", ";\n    ", ";\n"])), tokens_1.body1, mixins_1.applyDisabled, applyStatusColor);
exports.TextFieldHelper = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n\n    display: block;\n\n    margin-top: 0.25rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n\n    color: ", ";\n\n    ", ";\n    ", "\n"], ["\n    ", ";\n\n    display: block;\n\n    margin-top: 0.25rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n\n    color: ", ";\n\n    ", ";\n    ", "\n"])), tokens_1.caption, tokens_1.secondary, applyStatusColor, mixins_1.applyEllipsis);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=TextField.js.map